import React, { useEffect, useState } from "react";
import { Box, Button, Divider, Fab, Grid, Typography } from "@mui/material";
import { getAccountReachageDetails } from "./smbAccountReachageApi";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import SmbAccountReachargeCard from "./smbAccountReachageCard";
import AddIcon from "@mui/icons-material/Add";
import DisplayAnnualRecharge from "./displayAnnualRecharge";
import { getData } from "./smbAccountRechargeCustomApiHandler";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import DisplayQrScanModal from "./displayQrScanModal";
export default function SmbAccountReacharge() {
  const [data, setData] = useState();
  const [openT, setOpenT] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getData(getAccountReachageDetails, setData);
  }, []);
  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={{ sm: 4, xs: 2 }}
        pb={4}
        container
        spacing={2}
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
          minHeight: "100vh",
        }}
      >
        <Grid item xs={12} mt={1} mb={2}>
          <Grid container>
            <Grid
              item
              xs={10}
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: "10px",
                borderRadius: "5px",
                color: "#01008B", // optional text color
                textAlign: "left",
                fontFamily: "'Montserrat', sans-serif",
                fontSize: "20px",
                fontWeight: 500,
              }}
            >
              <Typography variant="h6">Account Recharge</Typography>
            </Grid>
            <Grid
              item
              xs={2}
              sx={{
                display: "flex",
                justifyContent: "end",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  backgroundColor: (theme) => theme.palette.primary.main,
                  borderRadius: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "50px",
                  width: "50px",
                }}
              >
                <QrCode2Icon
                  sx={{
                    color: "#fff",
                    fontSize: "40px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setOpenT(true);
                  }}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6} md={6} lg={4.5}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "5px",
                  border: "1px solid #01008B",
                  padding: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontWeight: "500",
                    fontSize: { xs: "10px", sm: "12px", md: "15px" },
                  }}
                >
                  Date Signed Up:
                </Typography>
                <Typography
                  component="span"
                  sx={{
                    fontSize: { xs: "10px", sm: "12px", md: "15px" },
                    fontWeight: "600",
                    color: (theme) => theme.palette.primary.main,
                  }}
                >
                  {convertDateToCustomFormat(
                    data?.accountSingedDate.split("T")[0]
                  )}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} lg={4.5}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  borderRadius: "5px",
                  border: "1px solid #01008B",
                  padding: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Typography
                  component="span"
                  sx={{
                    fontSize: { xs: "10px", sm: "12px", md: "15px" },
                    fontWeight: "500",
                  }}
                >
                  Account Validation Till:
                </Typography>
                <Typography
                  component="span"
                  sx={{
                    color: (theme) => theme.palette.primary.main,
                    fontSize: { xs: "10px", sm: "12px", md: "15px" },
                    fontWeight: "600",
                  }}
                >
                  {convertDateToCustomFormat(
                    data?.accountValidityDate?.split("T")[0]
                  )}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              md={12}
              lg={3}
              sm={12}
              sx={{
                display: "flex",
                justifyContent: {
                  xs: "center",
                  sm: "center",
                  md: "flex-end",
                },
                alignItems: "center",
                height: "100%",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: {
                    xs: "center",
                    sm: "center",
                    lg: "center",
                    md: "flex-end",
                  },
                  alignItems: "center",
                  height: "100%",
                  width: { lg: "100%", md: "auto", sm: "100%", xs: "100%" },
                }}
              >
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{
                    backgroundColor: (theme) => theme.palette.primary.main,
                    height: "100%",
                    fontSize: { xs: "10px", sm: "12px", md: "15px" },
                    fontWeight: "600",
                  }}
                  onClick={() => {
                    setOpen(true);
                  }}
                >
                  Click here to Recharge
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          mt={4}
          sx={{ backgroundColor: "#fff", borderRadius: "8px" }}
        >
          <Grid container spacing={2}>
            <Grid item xs={3} sx={{ textAlign: "center" }}>
              <Typography
                component="span"
                sx={{
                  fontWeight: 500,
                  color: "primary.main",
                  fontSize: { xs: "10px", sm: "12px", md: "15px" },
                }}
              >
                Recharge Plan
              </Typography>
            </Grid>
            <Grid item xs={3} sx={{ textAlign: "center" }}>
              <Typography
                component="span"
                sx={{
                  fontWeight: 500,
                  color: "primary.main",
                  fontSize: { xs: "10px", sm: "12px", md: "15px" },
                }}
              >
                Date
              </Typography>
            </Grid>
            <Grid item xs={3} sx={{ textAlign: "center" }}>
              <Typography
                component="span"
                sx={{
                  fontWeight: 500,
                  color: "primary.main",
                  fontSize: { xs: "10px", sm: "12px", md: "15px" },
                }}
              >
                Reference
              </Typography>
            </Grid>
            <Grid item xs={3} sx={{ textAlign: "center" }}>
              <Typography
                component="span"
                sx={{
                  fontWeight: 500,
                  color: "primary.main",
                  fontSize: { xs: "10px", sm: "12px", md: "15px" },
                }}
              >
                Amount
              </Typography>
            </Grid>
          </Grid>
          <Divider sx={{ backgroundColor: "#000" }} />
          <Grid
            container
            sx={{
              py: "10px",
              px: {xs:"0px", sm:"10px"},
            }}
          >
            <Grid item xs={12} sx={{ height: "60vh", overflowY: "auto" }}>
              <Grid
                container
                spacing={2}
                sx={{ padding: "0 0 10px 20px", marginTop: "0" }}
              >
                {data?.rechargeHistory?.map((item, index) => {
                  return (
                    <SmbAccountReachargeCard
                      item={item}
                      key={"anualCard" + index}
                    />
                  );
                })}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <DisplayQrScanModal open={openT} onClose={() => setOpenT(false)} />
        <DisplayAnnualRecharge
          open={open}
          setOpen={setOpen}
          cb={() => {
            getData(getAccountReachageDetails, setData);
          }}
        />
      </Box>
    </>
  );
}
